import {
  getMusicStyleSelectionGate,
} from './musicStylePreferences';
import {
  getStudentProfileCompletion,
  type ProfileCompletion,
} from './profileCompletion';

export type StudentAuthGateResult =
  | { action: 'showProfile'; profile: ProfileCompletion }
  | { action: 'showMusicStyles'; userId: string }
  | { action: 'continue' };

export async function resolveStudentAuthGates(
  userId: string,
  role: string,
): Promise<StudentAuthGateResult> {
  if (!userId) {
    return { action: 'continue' };
  }

  if (role === 'Student') {
    const missingProfile = await getStudentProfileCompletion(userId, role);
    if (missingProfile) {
      return { action: 'showProfile', profile: missingProfile };
    }
  }

  const needsMusicStyles = await getMusicStyleSelectionGate(userId, role);
  if (needsMusicStyles) {
    return { action: 'showMusicStyles', userId: needsMusicStyles };
  }

  return { action: 'continue' };
}
